var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessages(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "2.4 0 14.3 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.399902 2.99998C0.399902 2.36346 0.652759 1.75301 1.10285 1.30292C1.55293 0.852832 2.16338 0.599976 2.7999 0.599976H11.1999C11.8364 0.599976 12.4469 0.852832 12.897 1.30292C13.347 1.75301 13.5999 2.36346 13.5999 2.99998V7.79998C13.5999 8.4365 13.347 9.04694 12.897 9.49703C12.4469 9.94712 11.8364 10.2 11.1999 10.2H8.7999L5.1999 13.8V10.2H2.7999C2.16338 10.2 1.55293 9.94712 1.10285 9.49703C0.652759 9.04694 0.399902 8.4365 0.399902 7.79998V2.99998Z",
    fill: "#8D96B2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9999 5.39998V7.79998C15.9999 9.07301 15.4942 10.2939 14.594 11.1941C13.6938 12.0943 12.4729 12.6 11.1999 12.6H9.7935L7.6743 14.7204C8.0103 14.8992 8.3931 15 8.7999 15H11.1999L14.7999 18.6V15H17.1999C17.8364 15 18.4469 14.7471 18.897 14.297C19.347 13.8469 19.5999 13.2365 19.5999 12.6V7.79998C19.5999 7.16346 19.347 6.55301 18.897 6.10292C18.4469 5.65283 17.8364 5.39998 17.1999 5.39998H15.9999Z",
    fill: "#8D96B2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessages);
export default __webpack_public_path__ + "static/media/messages.9c5a87e2a611829c3f12a5f4ae0bf25c.svg";
export { ForwardRef as ReactComponent };